import React, { memo, ReactElement, useMemo } from "react";
import { GenericError } from "@swiggy-private/core-ui";
import { getPaymentErrorScreenAction } from "@payment-client/helpers/Misc";
import { PAYMENT_INITIAL_STATE } from "@payment-client";

interface PaymentModesErrorScreenProps {
    state: PAYMENT_INITIAL_STATE;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    routeData?: any;
}

function PaymentModesErrorScreen(props: PaymentModesErrorScreenProps): ReactElement {
    const { state, routeData } = props;

    const action = useMemo(() => getPaymentErrorScreenAction(state, routeData), [routeData, state]);

    return <GenericError action={action} />;
}

export default memo(PaymentModesErrorScreen);
